import { useTranslation } from "react-i18next";
import type { AiGuardNoticeView } from "@/features/ai";

type AiGuardNoticeListProps = {
  notices?: AiGuardNoticeView[];
};

function formatResumeDate(resetAt: string | null | undefined) {
  if (!resetAt) {
    return "";
  }

  const date = new Date(resetAt);
  if (Number.isNaN(date.getTime())) {
    return "";
  }

  return new Intl.DateTimeFormat(undefined, {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
}

function getNoticeValues(notice: AiGuardNoticeView) {
  return {
    minutes:
      typeof notice.minutesUntilReset === "number"
        ? notice.minutesUntilReset
        : typeof notice.retryAfterSeconds === "number"
          ? Math.max(1, Math.ceil(notice.retryAfterSeconds / 60))
          : undefined,
    resumeDate: formatResumeDate(notice.resetAt),
  };
}

export function AiGuardNoticeList({ notices = [] }: AiGuardNoticeListProps) {
  const { t } = useTranslation();

  if (notices.length === 0) {
    return null;
  }

  return (
    <div className="space-y-2 rounded-[1rem] border border-sky-300/35 bg-sky-50/70 px-3 py-3 text-sm text-sky-950">
      {notices.map((notice, index) => (
        <div key={`${notice.kind}-${notice.messageKey}-${index}`} className="space-y-1">
          <p>{t(notice.messageKey, getNoticeValues(notice))}</p>
          {notice.detailKey ? <p className="text-xs text-sky-900/75">{t(notice.detailKey)}</p> : null}
        </div>
      ))}
    </div>
  );
}
